import { render, staticRenderFns } from "./platformIntroduction.vue?vue&type=template&id=9489dfcc&scoped=true"
import script from "./platformIntroduction.vue?vue&type=script&lang=js"
export * from "./platformIntroduction.vue?vue&type=script&lang=js"
import style0 from "./platformIntroduction.vue?vue&type=style&index=0&id=9489dfcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9489dfcc",
  null
  
)

export default component.exports